// all styles here
import "./src/static/css/bootstrap.min.css";
import "./src/static/css/animate.min.css";
import "./src/static/css/boxicons.min.css";
import "./src/static/css/flaticon.css";
import "./node_modules/react-modal-video/css/modal-video.min.css";
import "react-accessible-accordion/dist/fancy-example.css";
import "react-image-lightbox/style.css";
import "./src/static/css/style.css";
import "./src/static/css/responsive.css";